<div matDialogTitle>Check Out Assets</div>
<mat-dialog-content>
  @for (asset of assets; track asset) {
    <div class="layout-row">
      <ah-asset-field-input class="flex-40" [group]="modalForm[asset.id]" [field]="nameField" [disabled]="true"></ah-asset-field-input>
      <ah-asset-field-input class="flex-30" [group]="modalForm[asset.id]" [field]="quantityOnHandField" [disabled]="true"></ah-asset-field-input>
      <ah-asset-field-input class="flex-30" [group]="modalForm[asset.id]" [field]="checkOutQtyField" [disabled]="saveDisabled"></ah-asset-field-input>
    </div>
  }
</mat-dialog-content>
<div>
  @for (item of savingMessage; track item) {
    <p-message [severity]="item.severity">{{item.summary}}</p-message>
  }
</div>
<div class="layout-row-end-none gap-20">
  <button [disabled]="saveDisabled" mat-raised-button matDialogClose>Cancel</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="saveDisabled">Save</button>
</div>
